<script setup>
import ReportCard from '../ReportCard.vue';

defineProps({
  metrics: {
    type: Array,
    default: () => [],
  },
  loadingMessage: {
    type: String,
    default: '',
  },
  selectedMetric: {
    type: String,
    default: '',
  },
});

defineEmits(['metricSelect']);

const trendClass = (trend, isInverseTrend) => {
  const isGoodTrend = isInverseTrend ? trend <= 0 : trend >= 0;
  return isGoodTrend
    ? 'text-green-600 dark:text-green-400'
    : 'text-red-500 dark:text-red-400';
};

const trendIconClass = trend => {
  return trend < 0
    ? 'border-x-4 border-x-transparent border-t-[8px]'
    : 'border-x-4 border-x-transparent border-b-[8px]';
};

const accentClass = accent => {
  const accents = {
    blue: 'bg-woot-50 text-woot-700 dark:bg-woot-900 dark:text-woot-300',
    cyan: 'bg-teal-50 text-teal-700 dark:bg-teal-900 dark:text-teal-300',
    violet:
      'bg-violet-50 text-violet-700 dark:bg-violet-900 dark:text-violet-300',
  };
  return accents[accent] || accents.blue;
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <ReportCard
      v-for="metric in metrics"
      :key="metric.key"
      compact
      class="flex items-center flex-1 gap-3"
      :is-loading="metric.isLoading"
      :loading-message="loadingMessage"
      selectable
      :selected="metric.key === selectedMetric"
      @select="$emit('metricSelect', metric)"
    >
      <span
        class="flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-md"
        :class="accentClass(metric.accent)"
      >
        <fluent-icon :icon="metric.icon" size="20" />
      </span>
      <div class="min-w-0">
        <p class="m-0 text-sm text-slate-700 dark:text-slate-200">
          {{ metric.label }}
        </p>
        <div class="flex items-baseline gap-3">
          <p
            class="mt-1 mb-0 text-3xl font-medium text-slate-900 dark:text-slate-50"
          >
            {{ metric.value }}
          </p>
          <div
            v-if="metric.trend"
            class="flex items-center gap-1 text-sm font-medium"
            :class="trendClass(metric.trend, metric.isInverseTrend)"
          >
            <span :class="trendIconClass(metric.trend)" />
            <span>{{ Math.abs(metric.trend) }}%</span>
          </div>
        </div>
      </div>
    </ReportCard>
  </div>
</template>
